import { TableColumn } from "react-data-table-component";
import { Download } from "react-feather";
import { Btn } from "../../AbstractElements";
import Swal from "sweetalert2";

//SERVICES
import { applicantAttachmentsService } from "../../Services/applicantsattachmentService";

//TYPE
import { ViewApplicantAttachments } from "../../Types/Applicants/ApplicantsAttachments";

const ActionCell = ({ row }: { row: ViewApplicantAttachments }) => {
  const handleDownload = async () => {
    try {
      const response = await applicantAttachmentsService.downloadAttachment(
        row.file_path,
      );

      const url = window.URL.createObjectURL(response.data);

      const link = document.createElement("a");
      link.href = url;
      link.download = row.file_name;

      document.body.appendChild(link);
      link.click();

      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error: any) {
      Swal.fire({
        icon: "error",
        title: `ERROR ${error.response?.status || ""}`,
        text: "Attachment Not Found.",
        confirmButtonColor: "#4e73df",
      });
    }
  };

  return (
    <div className="d-flex align-items-center gap-2">
      <Btn size="sm" color="primary" className="px-2" onClick={handleDownload}>
        <Download size={11} /> Download
      </Btn>
    </div>
  );
};

export const AttachmeneTableColumn: TableColumn<ViewApplicantAttachments>[] = [
  {
    name: "File Name",
    selector: (row) => row.file_name,
    cell: (row) => (
      <div style={{ whiteSpace: "pre-line" }}>{row.file_name}</div>
    ),
    sortable: true,
    center: false,
  },
  {
    name: "Attachment Category",
    selector: (row) => row.category,
    sortable: true,
    center: false,
  },
  {
    name: "DATE MODIFIED",
    selector: (row) => row.updated_date,
    cell: (row) => (
      <div style={{ whiteSpace: "pre-line" }}>
        {row.updated_by_user}
        {"\n"}
        {row.updated_date}
      </div>
    ),
    sortable: true,
    center: false,
  },
  {
    name: "ACTION",
    sortable: false,
    center: false,
    width: "150px",
    cell: (row) => <ActionCell row={row} />,
  },
];
